import { noteConfig, component, mergeConfig } from '@salutejs/plasma-new-hope/css';

import { config } from './Note.config';

const mergedConfig = mergeConfig(noteConfig, config);

export const Note = component(mergedConfig);
